import { TradeSettleStatusEnum } from '@talos/kyoko';
import type { ICellRendererParams } from 'ag-grid-community';
import { memo } from 'react';
import type { LPSettlementReportBlotterRow } from '../UnsettledTransactions/blotter/lpSettlementReportRow';
import { LPTradeStatusRenderer } from '../components/LPTradeStatusRenderer';

function isTradeSettleStatus(value: unknown): value is TradeSettleStatusEnum {
  return typeof value === 'string' && (Object.values(TradeSettleStatusEnum) as string[]).includes(value);
}

export const TradeStatusCell = memo(function CombinedStatusCell(
  props: ICellRendererParams<LPSettlementReportBlotterRow>
) {
  const { context, data, node, value } = props;

  if (!context.current.theme) {
    return null;
  }

  const status = node.group ? (isTradeSettleStatus(value) ? value : undefined) : data?.SettleStatus;

  if (!status) {
    return null;
  }

  return <LPTradeStatusRenderer theme={context.current.theme} status={status} />;
});
